import React from 'react'

const Paragraph = props => {
  return <p className="mt-3 text-base leading-6 text-gray-500" {...props} />
}

export default Paragraph
